export default "__VITE_ASSET__DdQtEFI8__"